<div class="relative flex h-full flex-col px-1 pb-4" *transloco="let t">
  @if (accountSelectionList().length === 0) {
    <div class="flex-1">
      {{ t("v2-layout.no_account_available") }}
    </div>
    <button iButton variant="secondary" size="md" (click)="cancellation.emit()">{{ t("common.back") }}</button>
  } @else {
    <div class="mb-4 flex items-center justify-between">
      <div class="w-[25rem]" iInputGroup>
        <IIcon name="search" />
        <input iInputGroupInput [placeholder]="t('common.search')" [(ngModel)]="searchValue" />
      </div>
      <button iButton variant="ghost" (click)="toggleSelectAllAccounts()">
        {{ isAllSelected() ? t("imultiselect.unselect_all") : t("imultiselect.select_all") }}
      </button>
    </div>

    <div class="flex flex-1 flex-col gap-4 overflow-auto">
      @for (a of filteredAccountSelectionList(); track a.accountId) {
        @let selectedMarketplaceNumber = selectedMarketplaceNumberByAccountId().get(a.accountId);
        @let hasAllMarketplacesSelected =
          (selectedMarketplaceNumber ?? 0) > 0 &&
          selectedMarketplaceNumber === eligibleMarketplacesByAccountId().get(a.accountId)?.length;

        <div>
          <div
            class="flex w-full gap-3 rounded-lg border border-gray-200 p-3"
            [ngClass]="[hasAllMarketplacesSelected ? 'bg-main-50/80 border-main-400' : 'border-gray-200 bg-white']"
            [attr.data-testid]="'account' + filteredAccountSelectionList().indexOf(a)"
          >
            <div>
              <ICheckbox
                [value]="hasAllMarketplacesSelected"
                (valueChange)="toggleSelectAllMarketplaces(a.accountId, !hasAllMarketplacesSelected)"
                testid="account-selection-checkbox"
              />
            </div>
            <div class="flex-1">
              <div class="flex w-full items-center justify-between">
                <div class="leading-5 text-gray-800">{{ a.accountName }}</div>
                <span class="text-xs text-gray-500">
                  {{ a.accountId }}
                </span>
              </div>
              <div class="text-sm text-gray-400">
                {{ a.isSeller ? t("common.seller") : t("common.vendor") }} - {{ a.marketplaces.length }}
                {{ a.marketplaces.length > 1 ? t("common.marketplaces") : t("common.marketplace") }}
                @if (selectedMarketplaceNumber && selectedMarketplaceNumber > 0) {
                  <span class="text-main-500 font-medium">
                    - {{ t("common.selected", { count: selectedMarketplaceNumber }) }}</span
                  >
                }
              </div>
              <div class="mt-2 flex flex-wrap gap-x-3">
                @for (m of a.marketplaces; track m.marketplace) {
                  <div [iTooltip]="m.disableReason">
                    <button
                      class="relative rounded-xl border px-2 py-1 text-sm text-gray-600 disabled:opacity-50"
                      [ngClass]="[m.isSelected ? 'bg-main-100 border-main-400' : 'border-gray-200 bg-white']"
                      (click)="toggleMarketplaceSelection(a.accountId, m.marketplace, !m.isSelected)"
                      [disabled]="!!m.disableReason"
                      [attr.data-testid]="m.marketplace"
                    >
                      {{ Marketplaces[m.marketplace].flag }}
                      {{ m.marketplace }}

                      @if (m.isSelected) {
                        <div
                          class="bg-main-400 absolute -top-1.5 -right-1.5 flex h-4 w-4 items-center justify-center rounded-full"
                        >
                          <IIcon name="check" class="text-xs text-white" />
                        </div>
                      }
                    </button>
                  </div>
                }
              </div>
            </div>
          </div>
        </div>
      }
    </div>
  }
</div>
